import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ClientAccount } from '../../Models/Domains/Account/SlAccounts/ClientAccount';
import { IJsonDate } from '../../System/IJsonDate';

declare var IS_RUNNING_IN_APP_POOL;

export class ClientAccountClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyId: string): Promise<ClientAccount, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Account/ClientAccount/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId }

    return AjaxWrapper.get<ClientAccount, any>(url, data);
  }
  public put(updatedAccount: ClientAccount, dateOfDeath: IJsonDate, dateOfNotification: IJsonDate): Promise<ClientAccount, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Account/ClientAccount/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { updatedAccount: updatedAccount, dateOfDeath: dateOfDeath, dateOfNotification: dateOfNotification }

    return AjaxWrapper.put<ClientAccount, any>(url, data);
  }
}

